export default function ({
  _editable,
  _uid,
  title,
  text,
  buttonText,
  image,
  url,
  id,
  width,
  height
}) {
  return {
    module: 'SDiscoverBanner',
    discoverBannerData: {
      _editable,
      _uid,
      title,
      text,
      buttonText,
      image,
      url,
      id,
      width,
      height
    }
  };
}
